export enum JobDetailsScreen {
  PART = 'JobDetailsPart',
  JOBS = 'JobDetailsJobs',
  BATCH = 'JobDetailsBatch',
  NC_FILE = 'JobDetailsNCFile',
  TOOLS = 'JobDetailsTools',
}

export enum JobDetailsScreenLink {
  PART = 'part',
  BATCH = 'batch',
  NC_FILE = 'nc-file',
  JOBS = 'jobs',
  TOOLS = 'tools',
}

export enum JobLevelSubScreen {
  GENERAL = 'General',
  TIMELINE = 'Timeline',
  DOCUMENTS = 'Documents',
}

export enum JobLevelSubScreenLink {
  GENERAL = 'general',
  TIMELINE = 'timeline',
  DOCUMENTS = 'documents',
}
